const STAFF_ROLE_LABELS = ["Cashier", "Security", "Kiosk", "Queue Viewer"];

export default function isStaffRole(groups) {
  if (!Array.isArray(groups) || groups.length === 0) return false;
  return groups.some((group) =>
    STAFF_ROLE_LABELS.some(
      (label) => label.toLowerCase() === group?.label?.toLowerCase()
    )
  );
}
